var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FFF5ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4339_173806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4934 25.0045C19.4934 28.4285 16.7177 31.2042 13.2937 31.2042C9.86953 31.2042 7.09375 28.4285 7.09375 25.0045C7.09375 21.5805 9.86953 18.8048 13.2937 18.8048C16.7177 18.8048 19.4934 21.5805 19.4934 25.0045Z",
    fill: "#ED342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2951 27.6602C11.9083 24.5168 10.8915 21.5803 10.8915 21.5803H8.76562C8.76562 21.5803 10.0595 25.3493 12.463 30.0627H14.1271C16.5306 25.3493 17.8245 21.5803 17.8245 21.5803H15.6986C15.6986 21.5803 14.6818 24.5168 13.2951 27.6602Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9991 24.6812C38.7973 24.6812 38.705 25.9753 38.705 25.9753H41.2929C41.2929 25.9753 41.2006 24.6812 39.9991 24.6812ZM42.8644 27.2693H38.705C38.705 27.2693 38.7973 28.6559 40.6461 28.6559C41.5703 28.6559 42.4947 28.3784 42.4947 28.3784L42.6797 29.8573C42.6797 29.8573 41.7553 30.2272 40.4612 30.2272C38.6125 30.2272 36.9487 29.3028 36.9487 26.7147C36.9487 24.6812 38.2429 23.3871 40.0915 23.3871C42.8644 23.3871 43.0492 26.1601 42.8644 27.2693ZM28.7208 25.0852L29.0071 23.559C29.0071 23.559 26.797 22.8884 25.0008 24.1312V30.2359H26.9084V25.2758C27.6715 24.7037 28.7208 25.0852 28.7208 25.0852ZM20.7692 24.6812C19.5676 24.6812 19.4752 25.9753 19.4752 25.9753H22.0632C22.0632 25.9753 21.9709 24.6812 20.7692 24.6812ZM23.6345 27.2693H19.4752C19.4752 27.2693 19.5676 28.6559 21.4162 28.6559C22.3403 28.6559 23.2648 28.3784 23.2648 28.3784L23.4498 29.8573C23.4498 29.8573 22.5253 30.2272 21.2313 30.2272C19.3826 30.2272 17.7188 29.3028 17.7188 26.7147C17.7188 24.6812 19.0129 23.3871 20.8615 23.3871C23.6345 23.3871 23.8192 26.1601 23.6345 27.2693ZM33.3763 27.9027C32.4077 25.5778 31.9235 23.3882 31.9235 23.3882L29.9866 23.3885C29.9866 23.3885 30.9552 27.1277 32.6018 30.2261H34.1508C35.7976 27.1277 36.7662 23.389 36.7662 23.389H34.8291C34.8291 23.389 34.345 25.5778 33.3763 27.9027Z",
    fill: "#03435F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    stroke: "#FECBAA",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4339_173806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 12.5455,
    fill: "white",
    transform: "translate(7 18.7273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerve);
export default __webpack_public_path__ + "static/media/verve.b35f27d83a93073af0f78edf027fcf6f.svg";
export { ForwardRef as ReactComponent };